export const LOAD_INSIGHTS = 'INSIGHTS:LOAD';
export const REFRESH_INSIGHTS = 'INSIGHTS:REFRESH';
export const UPDATE_CURRENT_INSIGHTS = 'CURRENT_INSIGHTS:UPDATE';
